module.exports = __webpack_public_path__ + "img/belted-kingfisher.3ed71271.jpg";